
<template>
  <div
    class="card-vip-info"
  >
    <div
      v-report="{
        id: 'button',
        params: {
          type: 'video_vip',
          ...vipCard.elementData,
          ...publicReport,
        },
      }"
      class="info"
      @click.stop="showVipModal"
    >
      <div
        class="title"
        :style="{
          color: cardStyle.fontColor,
        }"
      >
        <span>{{ vipCard?.title || '视频会员' }}</span>
        <ImageView
          class="arrow"
          :src="arrowRight"
          :watch-key="userIdentity"
          :style="{
            'tint-color': cardStyle.fontColor,
            '--tint-color': cardStyle.fontColor,
          }"
        />
      </div>
      <div
        class="subtitle"
        :style="{
          color: cardStyle.fontColor,
        }"
      >
        <span :title="vipCard?.subTitle || '立即开通'">{{ vipCard?.subTitle || '立即开通' }}</span>
      </div>
    </div>
    <div
      v-report="{
        id: 'button',
        params: {
          type: 'vip_activate',
          ...vipCard.elementData,
          ...publicReport,
        },
      }"
      class="button"
      :style="{
        background: cardStyle.btnColor,
        color: cardStyle.btnFontColor,
      }"
      @click.stop="showVipModal"
    >
      <span>{{ vipCard?.buttonText || '开通VIP' }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import ImageView from '@/components/image-view.vue';
import arrowRight  from '@/assets/img/arrow-right.png';
import { useEventBus } from '@common/logic';
import { EVENTS } from '@/common/bus';
import vipApi from '@/api/user';

const eventBus = useEventBus();

const showVipModal = () => {
  // 不用前端拼接跳转链接，由后端返回跳转
  console.info('[nav-login-panel] showVipModal', props.vipCard);
  eventBus.$emit(EVENTS.MINIPAYMODAL, {
    actionUrl: props.vipCard.actionUrl || '',
    ptag: props.vipCard.elementData?.ptag || 'ad.vipinfo.hvip.pc',
    aid: props.vipCard.elementData?.aid || 'V0$$4:3',
  });
  vipApi.getLimitWrite({
    ...(props.vipCard?.elementData || {}),
    action: 2, // 点击  
  });
};

const props = defineProps({
  vipCard: {
    type: Object,
    default: () => {
      {}
    },
  },
  userIdentity: {
    type: String,
    default: '',
  },
  loginInfo: {
    type: Object,
    default: () => {
      { }
    },
  },
  cardStyle: {
    type: Object,
    default: () => {
      { }
    },
  },
  publicReport: {
    type: Object,
    default: () => {
      { }
    },
  },
});


</script>


<style lang="scss" scoped>
.card-vip-info {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 138px;
  height: 98px;
  padding: 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
}
.info {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  .title {
    display: flex;
    align-items: center;
    height: 24px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
  }
  .subtitle {
    display: flex;
    align-items: center;
    height: 18px;
    font-size: 13px;
    font-weight: 400;
    opacity: 0.6;
    cursor: pointer;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 118px;
    }
  }
  .arrow {
    width: 16px;
    height: 16px;
  }
}
.button {
  width: 96px;
  height: 28px;
  background: rgba(255, 230, 165, 1);
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
  color: rgba(61, 40, 11, 1);
  cursor: pointer;
}
</style>
